const vapidKey = 'BMSw8k7OXZpQ5zIC_h-NdR9hjs48dzwB9y6SnSPxzMyKXajcnd_mypxAKRqfJSZcAQVlziDiAyLIQMqAnT21_zA'

const firebaseConfig = {
  apiKey: "AIzaSyBi2dUo-r6rR9ZkycTHMcNGFs2qOk1h1sY",
  authDomain: "lms-ltt-slldt.firebaseapp.com",
  projectId: "lms-ltt-slldt",
  storageBucket: "lms-ltt-slldt.firebasestorage.app",
  messagingSenderId: "529431457587",
  appId: "1:529431457587:web:82fcadce1304870300d846",
  measurementId: "G-WV5PDSG484"
};

export { vapidKey, firebaseConfig }
